//importing the client.js and constant.js to access it functions
import { todo_client } from './client';
import { todo_apiIndex } from '../constant';

//PC_FG_88.1
export const userRibbon = async (data) => {
    
    //PC_FG_88.2
    let body = {
        modulename: todo_apiIndex.module.getPolicy,
        methodname: todo_apiIndex.methodname.getUserRibbon,
        payload: data,
    };
    //PC_FG_88.3
    const response = await todo_client(body);
    //PC_FG_88.5
    return response;
};

//PC_FG_88.6
export const approverRibbon = async (data) => {
    
    //PC_FG_88.7
    let body = {
        modulename: todo_apiIndex.module.getPolicy,
        methodname: todo_apiIndex.methodname.ribbonAlert,
        payload: data,
    };
    //PC_FG_88.8
    const response = await todo_client(body);
    //PC_FG_88.10
    return response;
};
// PC_PD_29 to  PC_PD_31 - for API Call
// PC_PD_38 - response
export const getIndividualPolicyDirectoryDetails = async (data) => {
    
    let body = {
        modulename: todo_apiIndex.module.getPolicy,
        methodname: todo_apiIndex.methodname.getIndividualPolicyDirectoryDetails,
        payload: data,
    };

    const response = await todo_client(body);
    return response;
};

//PC_AH_3 function gets triggered
export const getPolicyAudit = async (data) => {
    
    let body = {
        modulename: todo_apiIndex.module.getPolicy,
        methodname: todo_apiIndex.methodname.getAuditHistory,
        payload: data,
    }
 
    const response = await todo_client(body);//PC_AH_2 calling client
    return response; //PC_AH_3 returns response
};

//PC_GD_44
export const getPolicyDropDown = async (todo_data) => {
    let body = {
        modulename: todo_apiIndex.module.getPolicy,
        methodname: todo_apiIndex.methodname.getFormDropDowns,
        payload: todo_data,
    };
    //PC_GD_45
    const response = await todo_client(body);
    return response; //PC_GD_46
};

// PC_PD_15,  PC_PD_16 - to declare getInactivePolices
// PC_PD_23 response
export const getInactivePolices = async (todo_data) => {
    let body = {
        modulename: todo_apiIndex.module.getPolicy,
        methodname: todo_apiIndex.methodname.getInActivePolices,
        payload: todo_data,
    };
    const response = await todo_client(body);
    return response;
};

//  PC_PD_14 ,  PC_PD_15 - to declare getActivePolices
// PC_PD_22 response
export const getActivePolices = async (todo_data) => {
    let body = {
        modulename: todo_apiIndex.module.getPolicy,
        methodname: todo_apiIndex.methodname.getActivePolices,
        payload: todo_data,
    };
    const response = await todo_client(body);
    return response;
};

//  PC_PD_14 ,  PC_PD_15 - to invoke getAllpolices
// PC_PD_22 - response
export const getAllpolices = async (todo_data) => {
    let body = {
        modulename: todo_apiIndex.module.getPolicy,
        methodname: todo_apiIndex.methodname.getAllpolices,
        payload: todo_data,
    };
    const response = await todo_client(body);
    return response;
};

//PC_AC_3 function triggers
export const getAckUsers = async (todo_data) => {
    // 
    let body = {
        modulename: todo_apiIndex.module.getPolicy,
        methodname: todo_apiIndex.methodname.getAckUsers,
        payload: todo_data,
    };
    const response = await todo_client(body); //PC_AC_4 calls client
    return response; //PC_AC_5 returns response
};

//PC_UAC_3 function triggeres
export const getUnAckUsers = async (todo_data) => {
    let body = {
        modulename: todo_apiIndex.module.getPolicy,
        methodname: todo_apiIndex.methodname.getUnAckUsers,
        payload: todo_data,
    }
    const response = await todo_client(body);//PC_UAC_4 calls client
    return response;//PC_UAC_5 returns response
}

//PC_GD_39 function gets triggered with body
export const repopulatePolicy = async (todo_data) => {
    // 
    let body = {
        modulename: todo_apiIndex.module.getPolicy,
        methodname: todo_apiIndex.methodname.repopulatePolicy,
        payload: todo_data,
    };
    //PC_GD_40 client gets called
    const response = await todo_client(body);
    return response; //PC_GD_41 return response
};

//PC_IP_22
export const insertPolicy = async (todo_data) => {
    // 
    let body = {
        modulename: todo_apiIndex.module.inserUpdatetPolicy,
        methodname: todo_apiIndex.methodname.insertPolicy,
        payload: todo_data,
    };
    const response = await todo_client(body); //PC_IP_23
    return response; //PC_IP_24
};

//PC_IP_26
export const updatePolicy = async (todo_data) => {
    // 
    let body = {
        modulename: todo_apiIndex.module.inserUpdatetPolicy,
        methodname: todo_apiIndex.methodname.updatePolicy,
        payload: todo_data,
    };
    const response = await todo_client(body); //PC_IP_27
    return response; //PC_IP_28
};

//PC_ARP_6 function gets triggered
export const approvalPolicy = async (todo_data) => {
    // 
    let body = {
        modulename: todo_apiIndex.module.inserUpdatetPolicy,
        methodname: todo_apiIndex.methodname.approvalPolicy,
        payload: todo_data,
    };
    const response = await todo_client(body); //PC_ARP_7 calling client
    return response; //PC_ARP_8 retutns response
};

//PC_FG_28
export const updateUserPolicy = async (todo_data) => {
    // 
    //PC_FG_28.1
    let body = {
        modulename: todo_apiIndex.module.inserUpdatetPolicy,
        methodname: todo_apiIndex.methodname.insertSignedPolicy,
        payload: todo_data,
    };
    //PC_FG_28.2
    const response = await todo_client(body);
    //PC_FG_28.4
    return response;
};

export const loadMyTodo = async (todo_data) => {
    let body = {
        modulename: todo_apiIndex.module.todo,
        methodname: todo_apiIndex.methodname.getMyTodo,
        payload: todo_data,
    };
    const response = await todo_client(body);
    return response;
};

export const searchMyTodo = async (todo_data) => {
    let body = {
        modulename: todo_apiIndex.module.todo,
        methodname: todo_apiIndex.methodname.searchMyTodo,
        payload: todo_data,
    };
    const response = await todo_client(body);
    return response;
};

export const sortMyTodo = async (todo_data) => {
    let body = {
        modulename: todo_apiIndex.module.todo,
        methodname: todo_apiIndex.methodname.sortMyTodo,
        payload: todo_data,
    };
    const response = await todo_client(body);
    return response;
};

export const filterMyTodo = async (todo_data) => {
    let body = {
        modulename: todo_apiIndex.module.todo,
        methodname: todo_apiIndex.methodname.filterMyTodo,
        payload: todo_data,
    };
    const response = await todo_client(body);
    return response;
};

export const deleteMyTodo = async (todo_id) => {
    let body = {
        modulename: todo_apiIndex.module.todo,
        methodname: todo_apiIndex.methodname.deleteMyTodo,
        payload: todo_id,
    };
    const response = await todo_client(body);
    return response;
};

export const getTodoFilterData = async () => {
    let body = {
        modulename: todo_apiIndex.module.todo,
        methodname: todo_apiIndex.methodname.getTodoFilterData,
    };
    const response = await todo_client(body);
    return response;
};

export const postMyTodo = async (todo_data) => {
    let body = {
        modulename: todo_apiIndex.module.todo,
        methodname: todo_apiIndex.methodname.postMyTodo,
        payload: todo_data,
    };
    const response = await todo_client(body);
    return response;
};

export const updateMyTodo = async (todo_data) => {
    let body = {
        modulename: todo_apiIndex.module.todo,
        methodname: todo_apiIndex.methodname.updateMyTodo,
        payload: todo_data,
    };
    const response = await todo_client(body);
    return response;
};

export const getTeamMembers = async (teamData) => {
    let body = {
        modulename: todo_apiIndex.module.teamMembers,
        methodname: todo_apiIndex.methodname.getTeamMembers,
        payload: teamData,
    };
    const response = await todo_client(body);
    return response;
};

export const getTeamMemberTodo = async (teamData) => {
    let body = {
        modulename: todo_apiIndex.module.teamMembers,
        methodname: todo_apiIndex.methodname.getTeamMemberTodo,
        payload: teamData,
    };
    const response = await todo_client(body);
    return response;
};

export const searchTeamMember = async (teamData) => {
    let body = {
        modulename: todo_apiIndex.module.teamMembers,
        methodname: todo_apiIndex.methodname.searchTeamMember,
        payload: teamData,
    };
    const response = await todo_client(body);
    return response;
};

export const sortTeamMember = async (teamData) => {
    let body = {
        modulename: todo_apiIndex.module.teamMembers,
        methodname: todo_apiIndex.methodname.sortTeamMember,
        payload: teamData,
    };
    const response = await todo_client(body);
    return response;
};

export const getFilterData = async (teamData) => {
    let body = {
        modulename: todo_apiIndex.module.teamMembers,
        methodname: todo_apiIndex.methodname.getFilterData,
    };
    const response = await todo_client(body);
    return response;
};

export const filterTeamMembers = async (teamData) => {
    let body = {
        modulename: todo_apiIndex.module.teamMembers,
        methodname: todo_apiIndex.methodname.filterTeamMembers,
        payload: teamData,
    };
    const response = await todo_client(body);
    return response;
};

//PC_CG_04 getConcerns will pass the emp_id to client.js to get data
export const getConcerns = async (emp_id) => {
    let body = {
        modulename: todo_apiIndex.module.concerns,
        methodname: todo_apiIndex.methodname.getConcerns,
        payload: emp_id,
    };
    const response = await todo_client(body);
    return response;
};

//PC_CG_04 getTeamConcerns will pass the details to client.js to get teamdata
export const getTeamConcerns = async (details) => {
    let body = {
        modulename: todo_apiIndex.module.concerns,
        methodname: todo_apiIndex.methodname.getTeamConcerns,
        payload: details,
    };

    const response = await todo_client(body);

    return response;
};

//PC_CG_46 deleteConcern will pass the concernDetails
export const deleteConcern = async (concernDetails) => {
    let body = {
        modulename: todo_apiIndex.module.concerns,
        methodname: todo_apiIndex.methodname.deleteConcern,
        payload: concernDetails,
    };
    const response = await todo_client(body);
    return response;
};

export const getConcernByID = async (concernDetails) => {
    let body = {
        modulename: todo_apiIndex.module.concerns,
        methodname: todo_apiIndex.methodname.getConcernByID,
        payload: concernDetails,
    };
    const response = await todo_client(body);
    return response;
};

export const viewConcern = async (concernDetails) => {
    let body = {
        modulename: todo_apiIndex.module.concerns,
        methodname: todo_apiIndex.methodname.viewConcern,
        payload: concernDetails,
    };
    const response = await todo_client(body);
    return response;
};

export const getDepartment = async () => {
    let body = {
        modulename: todo_apiIndex.module.concerns,
        methodname: todo_apiIndex.methodname.getDepartment,
    };
    const response = await todo_client(body);
    return response;
};

export const getPeople = async (concernDetails) => {
    let body = {
        modulename: todo_apiIndex.module.concerns,
        methodname: todo_apiIndex.methodname.getPeople,
        payload: concernDetails,
    };
    const response = await todo_client(body);
    return response;
};

export const postConcern = async (concernDetails) => {
    let body = {
        modulename: todo_apiIndex.module.concerns,
        methodname: todo_apiIndex.methodname.postConcern,
        payload: concernDetails,
    };
    const response = await todo_client(body);
    return response;
};

export const updateConcern = async (concernDetails) => {
    let body = {
        modulename: todo_apiIndex.module.concerns,
        methodname: todo_apiIndex.methodname.updateConcern,
        payload: concernDetails,
    };

    const response = await todo_client(body);
    return response;
};

export const updateViewConcern = async (concernData) => {
    let body = {
        modulename: todo_apiIndex.module.concerns,
        methodname: todo_apiIndex.methodname.updateViewConcern,
        payload: concernData,
    };

    const response = await todo_client(body);

    return response;
};

// PC_FG_06 getFAQ will pass the faqDetails payload to client.js
export const getFAQ = async (faqDetails) => {
    let body = {
        modulename: todo_apiIndex.module.faq,
        methodname: todo_apiIndex.methodname.getFAQ,
        payload: faqDetails,
    };
    const response = await todo_client(body);
    return response;
};

//PC_FG_27 getFAQByID will pass the faqID and categoryID to get the data to be edited
export const getFAQByID = async (faqDetails) => {
    let body = {
        modulename: todo_apiIndex.module.faq,
        methodname: todo_apiIndex.methodname.getFAQByID,
        payload: faqDetails,
    };
    const response = await todo_client(body);
    return response;
};

//PC_FF_15 postFAQ will pass the faqDetails to client.js for data insertion
export const postFAQ = async (faqDetails) => {
    let body = {
        modulename: todo_apiIndex.module.faq,
        methodname: todo_apiIndex.methodname.postFAQ,
        payload: faqDetails,
    };
    const response = await todo_client(body);
    return response;
};

//PC_FF_15 updateFAQ will pass the faqDetails to client.js for data updation
export const updateFAQ = async (faqDetails) => {
    let body = {
        modulename: todo_apiIndex.module.faq,
        methodname: todo_apiIndex.methodname.updateFAQ,
        payload: faqDetails,
    };
    const response = await todo_client(body);
    return response;
};

//PC_FG_14 deleteFAQ will pass the faqID to client.js for data deletion
export const deleteFAQ = async (faqDetails) => {
    let body = {
        modulename: todo_apiIndex.module.faq,
        methodname: todo_apiIndex.methodname.deleteFAQ,
        payload: faqDetails,
    };
    const response = await todo_client(body);
    return response;
};

//PC_FF_06 getCategories will get the categories to be loaded in the form
export const getCategories = async () => {
    let body = {
        modulename: todo_apiIndex.module.faq,
        methodname: todo_apiIndex.methodname.getCategories,
    };
    const response = await todo_client(body);
    return response;
};

export const notificationInsert = async (data) => {
    let body = {
        modulename: todo_apiIndex.module.faq,
        methodname: todo_apiIndex.methodname.insertNotification,
        payload: data,
    };
    const response = await todo_client(body);

    return response;
};
// PC_PD_09 to  PC_PD_11- getPolicyDirectory details
// PC_PD_17 - response
export const getPolicyDirectory = async (data) => {
    
    let body = {
        modulename: todo_apiIndex.module.getPolicy,
        methodname: todo_apiIndex.methodname.getPolicyDirectoryDetails,
        payload: data,
    }
 
    const response = await todo_client(body);
 
    return response;
};
